import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

// Lists
import ListGemeenten from './views/lists/ListGemeenten.vue';
import ListPartijen from './views/lists/ListPartijen.vue';
import ListPlatforms from './views/lists/ListPlatforms.vue';
import ListProjects from './views/lists/ListProjects.vue';
import ListThemas from './views/lists/ListThemas.vue';
import ListWijken from './views/lists/ListWijken.vue';

// Project
import ProjectBeknopt from './views/project/ProjectBeknopt.vue'
import ProjectExtended from './views/project/ProjectExtended.vue'

// Thema
import ThemaBeknopt from './views/thema/ThemaBeknopt.vue'

// Partijen
import PartijBeknopt from './views/stakeholder/PartijBeknopt.vue'

// Gemeenten
import GemeenteBeknopt from './views/gemeente/GemeenteBeknopt';

// Wijken
import WijkBeknopt from './views/wijken/WijkBeknopt';

// Pages 
import PageColofon from './views/pages/Colofon.vue';
import PageStagePlaatsen from './views/pages/StagePlaatsen.vue';
import PageProjectAanmaken from './views/pages/ProjectAanmaken.vue';
import PageContact from './views/pages/Contact.vue';
import PageAbout from './views/pages/About.vue';

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },

    // Project
    {
      path: '/verhalen/:slug',
      name: 'project-beknopt',
      component: ProjectBeknopt
    },
    {
      path: '/verhalen/:slug/volledig',
      name: 'project-extended',
      component: ProjectExtended
    },

    // Themas
    {
      path: '/themas/:slug',
      name: 'thema-beknopt',
      component: ThemaBeknopt
    },

    // Partijen 
    {
      path: '/betrokken-partijen/:slug',
      name: 'partij-beknopt',
      component: PartijBeknopt
    },

    // Gemeenten
    {
      path: '/gemeenten/:slug',
      name: 'gemeente-beknopt',
      component: GemeenteBeknopt
    },

    // Wijken
    {
      path: '/wijken/:slug',
      name: 'wijk-beknopt',
      component: WijkBeknopt
    },
    
    // Lists
    {
      path: '/gemeenten',
      name: 'list-gemeenten',
      component: ListGemeenten
    },
    {
      path: '/betrokken-partijen',
      name: 'list-partijen',
      component: ListPartijen
    },
    {
      path: '/platforms-bronnen',
      name: 'list-platforms',
      component: ListPlatforms
    },
    {
      path: '/verhalen',
      name: 'list-projecten',
      component: ListProjects
    },
    {
      path: '/themas',
      name: 'list-themas',
      component: ListThemas
    },
    {
      path: '/wijken',
      name: 'list-wijken',
      component: ListWijken
    },

    // Pages
    {
      path: '/pages/colofon',
      name: 'page-colofon',
      component: PageColofon
    },
    {
      path: '/pages/stage-plaatsen',
      name: 'page-stage',
      component: PageStagePlaatsen
    },
    {
      path: '/aanmelden',
      name: 'page-aanmelden',
      component: PageProjectAanmaken
    },
    {
      path: '/pages/project-aanmaken',
      name: 'page-aanmaken',
      component: PageProjectAanmaken
    },
    {
      path: '/pages/contact',
      name: 'page-contact',
      component: PageContact
    },
    {
      path: '/pages/over-energieke-verhalen',
      name: 'page-about',
      component: PageAbout
    }

  ]
})
